enum IconClasses {
	GRAPH = 'lnr-graph',
	PALETTE = 'lnr-palette',
	ENVELOPE = 'lnr-envelope',
	FUNNEL = 'lnr-funnel2',
	REDO = 'lnr-redo2',
	TIKTOK = 'lnr-tiktok',
	ELLIPSIS = 'lnr-ellipsis'
}

export { IconClasses };
